import React from 'react';
import PropTypes from 'prop-types';

import AmbBaseLink from '@amblique/base/app/components/link';
import {Link as ChakraLink} from '@salesforce/retail-react-app/app/components/shared/ui/Link';

const NATIVE_SCHEME = /^(mailto:|tel:)/i;

const Link = React.forwardRef(({href, to, useNavLink, parse, ...rest}, ref) => {
  const nativeHref = to ?? href;

  if (typeof nativeHref === 'string' && NATIVE_SCHEME.test(nativeHref)) {
    return <ChakraLink ref={ref} {...rest} href={nativeHref} />;
  }

  return (
    <AmbBaseLink
      ref={ref}
      href={href}
      parse={parse}
      to={to}
      useNavLink={useNavLink}
      {...rest}
    />
  );
});

Link.displayName = 'Link';
Link.propTypes = {
  href: PropTypes.string,
  to: PropTypes.string,
  useNavLink: PropTypes.bool,
  parse: PropTypes.bool,
};

export default React.memo(Link);
